import { getDate, getMonth, getYear } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export default function getNewsUrl(fullSlug, firstPublishedAt) {
    const timeZone = 'America/Sao_Paulo';

    const date = utcToZonedTime(firstPublishedAt, timeZone);

    const storyYear = getYear(date).toString();
    const storyMonth = (getMonth(date) + 1).toString().padStart(2, '0');
    const storyDay = getDate(date).toString().padStart(2, '0');

    if (fullSlug && firstPublishedAt) {
        return `/${fullSlug?.split('/')[0]}/${storyYear}/${storyMonth}/${storyDay}/${fullSlug?.split('/')[2]}`;
    } else {
        return '/nao-encontrado';
    }
}
